<template>
  <div class="sub-container">
    <div class="form-row-input" style="grid-column: span 2">
      <ejs-autocomplete
        ref="addressField"
        :dataSource='companyDataSource'
        :placeholder="searchAddressPlaceholder"
        data-test-address-info="saddr"
        :fields="addressFields"
        sortOrder="Ascending"
        filterType="Contains"
        float-label-type="Always"
        @change="onCompanySelection"
        :value="searchCompanyValue"
        width = "100%"
      >
      </ejs-autocomplete>
    </div>

    <div class="form-row-input">
      <ejs-textbox
        float-label-type="Always"
        :placeholder="companyNamePlaceholder"
        v-model="company.legalName"
        data-test-address-info="cmp"
        :maxlength="250"
      />
    </div>

    <div class="form-row-input">
      <ejs-autocomplete
        ref="addressAutoComplete"
        data-test-address-info="addr"
        :dataSource="melissaAddresses"
        :placeholder="companyAddressPlaceholder"
        :fields="addressAutocompleteFields"
        float-label-type="Always"
        @change="onAddressChange"
        :filtering="onAddressAutocompleteFiltering"
        :value="company.address"
        :maxlength="250"
      />
    </div>

    <div class="form-row-input">
      <ejs-textbox
        float-label-type="Always"
        placeholder="City/Town:"
        data-test-address-info="ct"
        v-model="company.cityName"
        :maxlength="250"
      />
    </div>

    <div class="form-row-input">
      <ejs-dropdownlist
        sortOrder="Ascending"
        :allowFiltering="true"
        float-label-type="Always"
        :dataSource="provinces"
        placeholder="Province:"
        data-test-address-info="prv"
        :fields="companyProvinceFields"
        v-model="company.provinceName"
        :maxlength="250"
      />
    </div>

    <div class="form-row-input">
      <ejs-textbox
        float-label-type="Always"
        placeholder="Postal Code/Zip:"
        data-test-address-info="pc"
        v-model="company.postalCode"
        :maxlength="10"
      />
    </div>
    <div class="form-row-input">
      <ejs-dropdownlist
        v-if="showCountryField"
        :fields="companyCountriesFields"
        float-label-type="Always"
        sortOrder="Ascending"
        :dataSource="countries"
        placeholder="Country:"
        data-test-address-info="cnt"
        v-model="company.countryName"
        :maxlength="250"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
// import { applierTypeEnum } from '../constants';
import { GET_MELISSA_ADDRESSES } from '../../../user-accounts/store';
import { getEServicesContacts } from '../../../auth/services/tms-api';

export default {
  name: 'AddressInfo',

  props: {
    applier: String,
    sites: Array,
    showCountryField: Boolean,
    company: Object,
    siteName: String,
    siteNumberFields: Object,
    siteDataSource: Array,
    siteNumberPlaceholder: String,
    companySearchType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      companyProvinceFields: {
        text: 'provinceName',
        value: 'provinceName',
        groupBy: 'countryName',
      },
      companyCountriesFields: { text: 'countryName', value: 'countryName' },
      addressAutocompleteFields: { value: 'Address.Address' },
      melissaCountry: 'CA',
      siteId: '',
      ownerID: null,
    };
  },

  computed: {
    ...mapGetters({
      provinces: 'provinces',
      companies: 'companies',
      countries: 'countries',
      melissaAddresses: 'melissaAddresses',
      permit: 'permit',
    }),

    companyAddressPlaceholder() {
      return `${this.applier} Company Address: `;
    },

    companyNamePlaceholder() {
      return `${this.applier} Company: `;
    },

    searchAddressPlaceholder() {
      return `(Search) ${this.applier} Company: `;
    },

    companyDataSource() {
      return this.companies;
    },

    addressFields() {
      return { value: 'text' };
    },
    addressName: {
      get() {
        return this.company?.address ?? '';
      },
      set(val) {
        this.$emit('updateCompanyLegalName', val);
      },
    },

    searchCompanyValue: {
      get() {
        return this.company.legalName ? `${this.company.legalName}, ${this.company.address ? this.company.address : ''}, ${this.company.cityName ? this.company.cityName : ''}, ${this.company.countryName ? this.company.countryName : ''}` : '';
      },
      set(val) {
        return val;
      },
    },
  },

  created() {
    // if (this.applier === applierTypeEnum.APPLICANT)
    // this.melissaCountry = `${this.melissaCountry}`;
  },

  methods: {
    ...mapActions({
      fetchMellisaAddresses: GET_MELISSA_ADDRESSES,
    }),

    onAddressChange(e) {
      if (e.e) {
        const updatedAdress = {
          ownerID: this.ownerID,
          address: this.company.address,
          cityName: this.company.cityName,
          provinceName: this.company.provinceName,
          postalCode: this.company.postalCode,
          countryName: this.company.countryName,
          legalName: this.company.legalName,
        };
        const { itemData } = e;
        if (itemData) {
          const selectedAddress = itemData.Address;
          if (selectedAddress.Address1) {
            updatedAdress.address = selectedAddress?.Address1 ?? '';
          } else {
            updatedAdress.address = selectedAddress.Address;
          }
          if (selectedAddress.Locality || selectedAddress.SubAdministrativeArea) {
            updatedAdress.cityName = selectedAddress.Locality
            || selectedAddress.SubAdministrativeArea;
          }
          if (selectedAddress.AdministrativeArea) {
            updatedAdress.provinceName = this.provinces.find(
              (x) => x.provinceCode === selectedAddress.AdministrativeArea,
            ).provinceName;
          }
          if (selectedAddress.PostalCode) { updatedAdress.postalCode = selectedAddress.PostalCode; }
          if (selectedAddress.CountryName) {
            updatedAdress.countryName = selectedAddress.CountryName.toLowerCase().startsWith('united')
              ? 'United States'
              : 'Canada';
          }
        } else {
          updatedAdress.address = null;
        }
        this.$emit('updateAddress', updatedAdress);
      } else if (!e.value) {
        const updatedAdress2 = {
          address: e.value,
          cityName: this.company.cityName,
          provinceName: this.company.provinceName,
          postalCode: this.company.postalCode,
          countryName: this.company.countryName,
          legalName: this.company.legalName,
        };
        this.$emit('updateAddress', updatedAdress2);
      }
    },

    async onCompanySelection(e) {
      if (e.e) {
        const { itemData } = e;
        const value = itemData && itemData.sourceCompanyId ? itemData.sourceCompanyId : '';
        this.$emit(
          'updateAddress',
          itemData || {
            cityName: null,
            provinceName: null,
            postalCode: null,
            countryName: null,
            legalName: null,
          },
        );
        if (value) {
          const contactResp = await getEServicesContacts(value);
          const contact = contactResp.data;
          // eslint-disable-next-line no-return-assign, no-param-reassign
          contact.forEach((x) => (x.name = `${x.fName} ${x.lName}`));
          this.$emit('updateContactFieldDS', contact);
        } else {
          this.$emit('updateContactFieldDS', null);
        }
      }
    },
    async onAddressAutocompleteFiltering(e) {
      e.preventDefaultAction = true;
      const enteredText = e.text;
      if (enteredText.length >= 3) {
        this.$refs.addressAutoComplete.ej2Instances.showSpinner();
        await this.fetchMellisaAddresses({
          melissaAddress1: enteredText,
          melissaCountry: this.melissaCountry,
        });
        e.updateData(this.melissaAddresses);
      }
    },
  },
};
</script>
